/**
 * @author Yohann Bianchi<yohann.b@lahautesociete.com>
 * @date 03/09/2018 09:28
 */

export default {
    props: {
        pdfFile:         { type: String, default: null },
        mediathequeFile: { type: String, default: null },

    },

    computed: {
        pdfFileExists () {
            return !!this.pdfFile.trim();
        },

        mediathequeFileExists () {
            return !!this.mediathequeFile.trim();
        },
    },
};
